import { FormattedMessage } from 'react-intl';
import React from 'react';

/**
 * Helper method to construct formatted headers for table columns.
 * @param headers
 * @returns {*}
 */
export const getFormattedHeaders = (headers) => {
    return headers.map(header => ({ ...header, text: <FormattedMessage id={header.text}/> }));
};